module.exports = __webpack_public_path__ + "static/step4-427a19a0dbc2d90ee41da8bb226f7470.png";